// extracted by mini-css-extract-plugin
export default {"wrapper":"HomePage_wrapper__PHtr1","content":"HomePage_content__dVyV7"};